import { getAccountId, getUrlWithSearchParams } from "../common/helpres/link";
import { baseFetch } from "./baseFetch";
export const getCsrf = () => {
    const key = document.querySelector("meta[name=csrf-param]")?.content || "";
    const value = document.querySelector("meta[name=csrf-token]")?.content || "";
    return key ? { key, value } : null;
};
const csrf = getCsrf();
/**
 * Sends an HTTP request with CSRF token and optional logout token.
 *
 * @template P - The request payload type.
 * @template R - The response type.
 * @param {Object} options - The request options.
 * @param {string} [options.logoutToken] - The logout token.
 * @param {string} [options.accountId] - The account ID.
 * @param {IFetchInput<P>} options.props - The fetch input properties.
 * @returns {Promise<R>} The promise that resolves to the response.
 */
export const csrfFetch = ({ logoutToken, accountId, ...props }) => {
    const headers = {
        ...(csrf ? { "x-csrf-token": csrf.value, "X-Requested-With": "XMLHttpRequest" } : {}),
        ...(logoutToken ? { Authorization: "Bearer " + logoutToken } : {}),
    };
    const url = getUrlWithSearchParams(props.url, { accountId: accountId || getAccountId() || window.__ACCOUNT_ID__ }, { hasAccountId: false });
    return baseFetch({ ...props, url, withCredentials: true, headers });
};
